import { Typography } from '../../../Typography';

type ChartTooltipProps = {
  active?: boolean;
  payload?: {
    payload: {
      price: number;
      timestamp: number;
    };
  }[];
};

const formatDate = (timestamp: number) => {
  const date = new Date(timestamp);

  const formattedDate = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);

  const formattedTime = new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).format(date);

  return {
    formattedDate,
    formattedTime,
  };
};

export const ChartTooltip = ({ active, payload }: ChartTooltipProps) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const { formattedDate, formattedTime } = formatDate(payload[0].payload.timestamp);
  return (
    <div
      className="
        flex flex-col items-start gap-1
        px-3 py-2 rounded-lg
        bg-card-default-default-bg
        border border-base-border-dark
      "
    >
      <span>
        <Typography variant="caption-xs" color="primary">
          {formattedDate}&nbsp;
        </Typography>
        <Typography variant="caption-xs" color="tertiary">
          {formattedTime}
        </Typography>
      </span>
      <span>
        <Typography variant="caption-xs" color="tertiary">
          Price:&nbsp;
        </Typography>
        <Typography variant="caption-xs" color="primary">
          {' '}
          {payload[0].payload.price}
        </Typography>
      </span>
    </div>
  );
};
